import { render } from "./DefineObjectsAndStaticRegion.vue?vue&type=template&id=7e0ec512"
import script from "./DefineObjectsAndStaticRegion.vue?vue&type=script&lang=js"
export * from "./DefineObjectsAndStaticRegion.vue?vue&type=script&lang=js"

import "./DefineObjectsAndStaticRegion.vue?vue&type=style&index=0&id=7e0ec512&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__